/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {KTIcon} from '@_metronic/helpers'

const SidebarFooter = () => {
  const intl = useIntl()
  const currentLocale = intl.locale

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <a
        href='https://thesimstree-guide.notion.site/thesimstree-guide/972576f23cd142a69c4e6da1c6bf99f2'
        target='_blank'
        className='btn btn-outline btn-outline-dashed btn-outline-success btn-active-light-success flex-center overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='Instructions on how to use the service'
      >
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
        <span className='btn-label'>{intl.formatMessage({id: 'SIDEBAR.MENU.FAQ'})}</span>
      </a>
    </div>
  )
}

export {SidebarFooter}
